import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-prepaid-dth-recharge',
    templateUrl: './prepaid-dth-recharge.component.html',
    styleUrls: ['./prepaid-dth-recharge.component.scss']
})
export class PrepaidDTHRechargeComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit() {}

}